import React, { useRef, useState } from "react";
import { useForm, ValidationError } from "@formspree/react";
import Recaptcha from "react-google-recaptcha";
import ReCAPTCHA from "react-google-recaptcha";
export default function ContactForm() {
  const [state, handleSubmit] = useForm("mjvjndkd");
  const [name, setName] = useState();
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState();
  const [massege, setMassege] = useState();
  const [subject, setSubgect] = useState();
  const [capcha, setCapcha] = useState(false);
  const recaptchaRef = useRef();
  async function handleUserInput(e) {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "email") {
      setEmail(value);
    }
    // if ((name = "telephone")) {
    //   setTelephone(value);
    // }
    // if ((name = "subject")) {
    //   setSubgect(value);
    // }
  }
  function checkEmail(e) {
    e.preventDefault();
    console.log(email);
    if (email === "") {
      alert("please fill your email");
    }
    if (capcha === false) {
      alert("please verify that you are a human!");
    }
  }
  const verifyCallback = function (response) {
    if (response) {
      setCapcha(true);
      console.log(capcha);
    }
  };

  if (state.succeeded) {
    return (
      <p className="contact-massege">Thank You! We will contact you shortly…</p>
    );
  }
  const callbackCapcha = function () {
    console.log("Done!!!!");
  };
  function onChange(value) {
    console.log("Captcha value:", value);
    setCapcha(value);
  }
  return (
    <form
      onSubmit={email !== "" && capcha !== false ? handleSubmit : checkEmail}
    >
      <div className="form-2-col">
        <input
          type="text"
          placeholder="Name"
          name="name"
          id="full-name"
          onChange={(e) => handleUserInput(e)}
        />
        <ValidationError
          prefix="Name"
          field="full-name"
          errors={state.errors}
        />
        <input
          placeholder="Email"
          id="email"
          type="email"
          name="email"
          onChange={(e) => handleUserInput(e)}
        />
        <ValidationError prefix="Email" field="email" errors={state.errors} />
      </div>
      <div className="form-2-col">
        <input
          placeholder="Phone"
          id="telephone"
          type="telephone"
          name="telephone"
          onChange={(e) => handleUserInput(e)}
        />
        <ValidationError
          prefix="Telephone"
          field="telephone"
          errors={state.errors}
        />
        <input
          type="text"
          placeholder="Subject"
          name="subject"
          id="email-subject"
          onChange={(e) => handleUserInput(e)}
        />
      </div>
      <div className="message">
        <textarea
          id="message"
          name="message"
          cols="30"
          rows="10"
          placeholder="Message"
          onChange={(e) => handleUserInput(e)}
        ></textarea>
        <ValidationError
          prefix="Message"
          field="message"
          errors={state.errors}
        />
      </div>
      <div className="contact-submit">
        <button type="submit" disabled={state.submitting}>
          Submit
        </button>
        {/* <Recaptcha
          sitekey={process.env.GATSBY_RECAPTCHA_KEY}
          onloadCallback={callbackCapcha}
          verifyCallback={verifyCallback}
        /> */}
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={process.env.GATSBY_RECAPTCHA_KEY}
          onChange={onChange}
        />
      </div>
    </form>
  );
}
